var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot",attrs:{"id":"foot"},on:{"click":_vm.toPay}},[_c('img',{attrs:{"src":require("../../assets/img/kaitongyongjiuvip@2x.png"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("立即开通")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebc6c3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/vipBotton.vue
// module id = null
// module chunks = 